export { hy } from '@payloadcms/translations/languages/hy'
